import styled from 'styled-components'
import {TableHeaderSortProps, TableHeaderStyleProps} from './TableFooterProps'

export const TableFooterColumn = styled.th<TableHeaderStyleProps & TableHeaderSortProps>`
  height: ${({headerHeight, theme}) => headerHeight ?? theme.table.tableHeader.height};

  font-size: ${({headerFontSize, theme}) => headerFontSize ?? theme.table.tableHeader.fontSize};
  text-align: ${({headerTextAlign, theme}) => headerTextAlign ?? theme.table.tableHeader.textAlign};
  font-family: ${({headerFontFamily, theme}) => headerFontFamily ?? theme.table.tableHeader.fontFamily};
  font-weight: ${({headerFontWeight, theme}) => headerFontWeight ?? theme.table.tableHeader.fontWeight};

  border-top: ${(props) => props.headerBorderTop && props.headerBorderTop};
  border-left: ${(props) => props.headerBorderLeft && props.headerBorderLeft};
  border-right: ${(props) => props.headerBorderRight && props.headerBorderRight};
  border-bottom: ${({headerBorderBottom, theme}) => headerBorderBottom ?? theme.table.tableHeader.borderBottom};
  border: ${(props) => props.headerBorder && props.headerBorder};
  border-color: ${({headerBorderColor, theme}) => headerBorderColor ?? theme.table.tableHeader.borderColor};

  padding: ${({headerPadding, theme}) => headerPadding ?? theme.table.tableHeader.padding};
  padding-top: ${(props) => props.headerPaddingTop && props.headerPaddingTop};
  padding-left: ${(props) => props.headerPaddingLeft && props.headerPaddingLeft};
  padding-right: ${(props) => props.headerPaddingRight && props.headerPaddingRight};
  padding-bottom: ${(props) => props.headerPaddingBottom && props.headerPaddingBottom};

  color: ${({headerColor, theme}) => headerColor ?? theme.table.tableHeader.color};
  background-color: ${({headerBackgroundColor, theme}) => headerBackgroundColor ?? theme.table.tableHeader.backgroundColor};

  cursor: ${({cursor}) => cursor ?? 'auto'};

  ${({charAmount}) => `min-width: ${(charAmount ?? 0) + 4}ch`};

  :first-child {
    border-top-left-radius: ${(props) => props.headerBorderRadius && props.headerBorderRadius};
    border-bottom-left-radius: ${(props) => props.headerBorderRadius && props.headerBorderRadius};
  }

  :last-child {
    border-top-right-radius: ${(props) => props.headerBorderRadius && props.headerBorderRadius};
    border-bottom-right-radius: ${(props) => props.headerBorderRadius && props.headerBorderRadius};
  }

  @media (max-width: 767px) {
    font-size: 10px;
  }
`

export const TableFooterRow = styled.tr<TableHeaderStyleProps>`
  border-left: ${(props) => props.headerExternalLeftBorder && props.headerExternalLeftBorder};
  border-right: ${(props) => props.headerExternalRightBorder && props.headerExternalRightBorder};

  @media only screen and (max-width: 760px), (min-device-width: 761px) and (max-device-width: 1024px) {
    margin-bottom: 0.625em;
  }
`
